import { useState } from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ShortenResponse } from '../lib/api'
import styles from './ResultCard.module.css'

interface Props { result: ShortenResponse }

export default function ResultCard({ result }: Props) {
  const [copied, setCopied] = useState(false)

  function copy() {
    navigator.clipboard.writeText(result.shortUrl)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <motion.div
      className={styles.card}
      initial={{ opacity: 0, scale: .96, y: 10 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ type: 'spring', stiffness: 300, damping: 24 }}
    >
      <div className={styles.left}>
        <span className={styles.label}>Your shortened link</span>
        <span className={styles.shortUrl}>{result.shortUrl}</span>
        <span className={styles.original} title={result.originalUrl}>
          ↳ {result.originalUrl}
        </span>
      </div>
      <div className={styles.actions}>
        <button className={`${styles.btn} ${copied ? styles.copied : ''}`} onClick={copy}>
          {copied ? '✓ Copied' : 'Copy'}
        </button>
        <Link className={styles.statsLink} to={`/stats/${result.shortCode}`}>
          Stats →
        </Link>
      </div>
    </motion.div>
  )
}
